require('./main.css');
require('ol/ol.css');
//import 'react-app-polyfill/ie9'; //currently commenting out, as we don't support IE
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App';
import store from './store';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import mapContainer from './map/mapContainer';
import baseLayerMap from './baseLayers/mapContainer';
import mapPopupContainer from './mapPopup/mapContainer';
import mapDrawContainer from './draw/mapContainer';
import { drawFeaturesChange, clearDraw, toggleDraw } from './draw/actions';
import { setDescriptionFormat } from './contextmenu/actions';
import centerOnExtent from './map/centerOnExtent';
import centerOnGeometries from './map/centerOnGeometries';
import { drawSource } from './draw/mapAssets';
import { transformer } from './transformCoordinates';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

proj4.defs('EPSG:3059', '+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs');
proj4.defs('EPSG:25884', '+proj=tmerc +lat_0=0 +lon_0=24 +k=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs');
register(proj4);

const theme = createMuiTheme({
	palette: {
		action: { main: '#fff', hover: '#00264A', hoverText: '#fff' },
		primary: { main: 'rgb(0, 38, 74)' },
		secondary: { main: '#00264A' },
		success: { main: '#deefd7' },
		gray: { main: '#515151' },
	},
	typography: {
		htmlFontSize: 14,
	},
	overrides: {
		MuiTabIndicator: {
			display: 'none',
			opacity: 0,
			root: {
				display: 'none',
				opacity: 0,
			},
		},
		MuiAppBar: {
			root: {
				padding: '4px 4px 0 4px',
			},
			colorPrimary: {
				//  backgroundColor:'#fff',
				//  color: '#000'
			},
		},
		MuiTypography: {
			subheading: {
				lineHeight: '2.4',
				fontSize: '0.9rem',
				//fontWeight: 600,
				fontFamily: "'Open Sans', sans-serif",
			},
			body1: {
				fontSize: '0.9rem',
			},
		},
		MuiInputLabel: {
			root: {
				fontSize: '0.9rem',
			},
		},
		MuiButton: {
			// Name of the styleSheet
			root: {
				// Name of the rule
				background: '#fff', //'linear-gradient(45deg, #021c35 30%, #420003 90%)',
				borderRadius: 0,
				border: 0,
				color: '#565656',
				//    height: 48,
				padding: '0 15px',
			},
		},
		MuiPaper: {
			root: {
				padding: '4px',
			},
		},
	},
});

export let editCallback;

console.log('jsGeomEditor ');

class jsGeomEditor {
	constructor({ id }) {
		render(
			<Provider store={store}>
				<MuiThemeProvider theme={theme}>
					<App />
				</MuiThemeProvider>
			</Provider>,
			document.getElementById(id)
		);

		mapContainer(store);
		//dataLayerContainer(store);
		baseLayerMap(store);
		//mapRouteContainer(store);
		//mapPointsContainer(store);
		//mapSeachContainer(store);
		//mapSpeedCamContainer(store);
		mapPopupContainer(store);
		mapDrawContainer(store);
		//urlContainer(store);
		//gpsContainer(store);
		//mapMB(store);
	}

	add(data, zoomToFeatures = true) {
		if (typeof data.type === 'undefined') {
			var geojsonObject = {
				type: 'FeatureCollection',
				features: data,
			};
		} else {
			var geojsonObject = data;
		}

		store.dispatch(drawFeaturesChange({ GeoJSON: geojsonObject, updateSource: 'API' }));
		if (zoomToFeatures) {
			centerOnGeometries(geojsonObject);
		}
	}

	zoomToFeatures() {
		centerOnExtent(drawSource);
	}
	get() {
		var state = store.getState();
		return state.draw.featuresGeoJSON;
		//find get geomteries
	}

	transform(data, from, to) {
		return transformer(data, from, to)
	}

	clear() {
		store.dispatch(clearDraw({ updateSource: 'JSAPI' }));
	}

	setDescriptionFormat(func) {
		store.dispatch(setDescriptionFormat(func));
	}

	setEditCallback(cbname) {
		editCallback = cbname;
	}

	changeDraw(newValue = null) {
		const name = newValue === null ? 'Point' : (newValue === false ? '' : newValue);
		store.dispatch(toggleDraw({drawType: name}));
	}
}

window.jsGeomEditor = jsGeomEditor;
